// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2w6N3","cell":"ColumnAccessor_cell__1qAD6","firstCellAccent":"ColumnAccessor_firstCellAccent__1Ch89"};